import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {normalizeStyles} from '@webs/components-library/theming';

@customElement('webs-header-tag')
export class HeaderTag extends LitElement {

  static styles = [
    normalizeStyles,
    css`
    .m-header-tag a {
      align-items: center;
      background: var(--color-light-grey);
      border-radius: 49.7px;
      color: var(--color-black) !important;
      display: block;
      font-size: .7rem;
      font-family: var(--font-family-alternative);
      font-weight: var(--font-weight-semibold);
      line-height: 1.3;
      padding: .35rem .8rem;
      transition: background-color .1s linear,border-color .1s linear,color .1s linear;
      text-decoration: none;
      cursor: pointer;
      margin: 0 .3rem .5rem;
    }
    .m-header-tag a:hover {
      background-color: var(--color-base);
      color: var(--color-white)!important;
    }
    `
  ]

  @property()
  href: string;

  @property()
  text: string;

  protected render(): unknown {
    return html`
    <div class="m-header-tag">
      <a href="${this.href}">${this.text}</a>
    </div>
    `
  }
}
